import { useWorkflowTemplateVersion } from '@commenda/api';
import { useCallback, useRef } from 'react';
import { usePolling } from '../../../hooks/usePolling';

const POLL_INTERVAL_MS = 2000;

/** Polls the version while the caller says the agent may be editing it. Whether a run that claims to be
 * in flight has actually stalled is the chat's judgement, and it says so by passing false. */
export function useBuilderVersionPolling(
  workflowTemplateVersionId: string | null,
  options: Readonly<{ isEditInProgress: boolean }>
) {
  const { data, error, isLoading, mutate } = useWorkflowTemplateVersion(
    workflowTemplateVersionId
  );

  // usePolling captures its callback once while SWR rebinds mutate per key, so without a ref a fork would
  // keep revalidating the version the author just navigated away from.
  const mutateRef = useRef(mutate);
  mutateRef.current = mutate;

  const refreshNow = useCallback(async () => {
    await mutateRef.current();
  }, []);

  usePolling(
    useCallback(() => {
      mutateRef.current();
    }, []),
    {
      enabled: options.isEditInProgress,
      interval: POLL_INTERVAL_MS,
      timeout: 0,
    }
  );

  return {
    version: data?.workflowTemplateVersion ?? null,
    refreshNow,
    isLoading,
    error,
  };
}
